export default __webpack_public_path__ + "static/media/guildturk.07c89a3e.png";